import { h } from "@stencil/core";

export const ChevronDown = () => (
    <svg viewBox="0 0 32 32" role="img" fill="currentColor">
        <path d="M5.376 14.784v1.696l5.44 3.264c2.976 1.792 5.472 3.264 5.504 3.264s2.592-1.472 5.6-3.296l5.472-3.264v-1.696c0-1.472-0.032-1.632-0.224-1.568-0.096 0.032-2.592 1.504-5.504 3.264l-5.312 3.2-5.376-3.232c-2.976-1.792-5.44-3.264-5.504-3.264-0.032-0.032-0.096 0.704-0.096 1.632"></path>
    </svg>
);
